module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABA0lEQVQ4T82U4RHBQBSEdyugAy3oAB1QATqgAnRABXSCDrSgAypYs5k7E5GTRH7wZvIjc5sve+/tPKJGSeqSvNWQglUiSX0A+6AbVYE/AgPsCKAbgHZp6CVlJAmUNA7OIiwyDJ2QPJVBS4GSZrlrpszMSR6Kh29ASWsAq6rehvMtyWVe+wKU5D9Oa8Ki7EByHl8yoGMRrui+fVMeUpYABpgn6Xi0KUMnBnpagzak3LdXA+3MV7bLNjUCcHsORZLa0EhmrJ8AdyQXIQ3JWDVxuCHpsDteydD/PfBOMlsi+aF4i3RKJu2+xSXgpeGnWGeSwyLQQveo1zA+VwDjuCMrN3ZDOB6gBHM8KYfAtgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-icon.png
// module id = Podj
// module chunks = 3